class FacetFiltersForm extends HTMLElement {
constructor() {
  super();
  this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

  this.debouncedOnSubmit = debounce((event) => {
    this.onSubmitHandler(event);
  }, 500);

  const facetForm = this.querySelector('form');
  facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

  // NEU: Spezifischer Event Listener nur für Sortierung
  const sortSelect = this.querySelector('#SortBy, [name="sort_by"]');
  if (sortSelect) {
    sortSelect.addEventListener('change', this.debouncedOnSubmit.bind(this));
  }

  const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
  if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
}

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    // Theme hat nur #ProductCountDesktop (kein #ProductCount) -> null-sicher, sonst Absturz beim Sortieren
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const source = doc.getElementById('ProductCount') || doc.getElementById('ProductCountDesktop');
    if (!source) return;
    const count = source.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  const mobileForm = document.getElementById('FacetFiltersFormMobile');
if (mobileForm) {
  const menuDrawer = mobileForm.closest('menu-drawer');
  if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
    menuDrawer.bindEvents();
  }
 }
}

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
  event.preventDefault();
  const sortFilterForms = document.querySelectorAll('facet-filters-form form');
  
  if (event.srcElement.className == 'mobile-facets__checkbox') {
    const searchParams = this.createSearchParams(event.target.closest('form'))
    this.onSubmitForm(searchParams, event)
  } else {
    const forms = [];
    const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

    // Prüfe ob es ein Sort-Event ist
    const isSortEvent = event.target && (event.target.id === 'SortBy' || event.target.name === 'sort_by');

    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          const noJsElements = document.querySelectorAll('.no-js-list');
          noJsElements.forEach((el) => el.remove());
          
          // Bei Sort-Event: Hole aktuelle URL-Parameter für Filter
          if (isSortEvent && form.id === 'FacetSortForm') {
            // Erstelle Form Data nur für Sort
            const sortFormData = new FormData(form);
            let sortParams = new URLSearchParams(sortFormData).toString();
            
            // Füge bestehende Filter aus URL hinzu
            const currentUrl = new URL(window.location);
            currentUrl.searchParams.forEach((value, key) => {
              if (key !== 'sort_by' && key !== 'page') {
                sortParams += (sortParams ? '&' : '') + key + '=' + encodeURIComponent(value);
              }
            });
            
            forms.push(sortParams);
          } else {
            forms.push(this.createSearchParams(form));
          }
        }
      } else if (form.id === 'FacetFiltersFormMobile') {
        forms.push(this.createSearchParams(form));
      }
    });
    
    this.onSubmitForm(forms.join('&'), event)
  }
}

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

// Filter Expand/Collapse Funktionalität - KORRIGIERT
// Diesen Code am Ende Ihrer bestehenden JavaScript-Datei hinzufügen

document.addEventListener('DOMContentLoaded', function() {
    
    function initializeFilterToggle() {
        // Warte bis CloudSearch geladen ist
        setTimeout(() => {
            const filters = document.querySelectorAll('.cloud-search-filter');
            
            if (filters.length === 0) {
                // Wenn noch keine Filter da sind, versuche es in 500ms nochmal
                setTimeout(initializeFilterToggle, 500);
                return;
            }
            
            filters.forEach((filter, index) => {
                const filterName = filter.querySelector('.cloud-search-filter__name');
                const content = filter.querySelector('.cloud-search-filter__content');
                
                if (!filterName || !content) return;
                
                // Entferne alle bestehenden Event Listener
                const newFilterName = filterName.cloneNode(true);
                filterName.parentNode.replaceChild(newFilterName, filterName);
                
                // WICHTIG: NUR die ersten 3 Filter (Index 0, 1, 2) sind geöffnet
                if (index < 3) {
                    filter.classList.add('expanded');
                    content.style.maxHeight = content.scrollHeight + 'px';
                } else {
                    // ALLE anderen Filter sind geschlossen
                    filter.classList.remove('expanded');
                    content.style.maxHeight = '0';
                }
                
                // Neuen Click-Event hinzufügen
                newFilterName.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    const isExpanded = filter.classList.contains('expanded');
                    
                    if (isExpanded) {
                        // Filter einklappen
                        filter.classList.remove('expanded');
                        content.style.maxHeight = '0';
                    } else {
                        // Filter ausklappen
                        filter.classList.add('expanded');
                        content.style.maxHeight = content.scrollHeight + 'px';
                    }
                });
            });
        }, 100);
    }
    
    // Initialisiere beim ersten Laden
    initializeFilterToggle();
    
    // Überwache CloudSearch Filter Sidebar für dynamische Updates
    const targetNode = document.getElementById('cloud_search_filters_sidebar');
    if (targetNode) {
        const observer = new MutationObserver(function(mutations) {
            let shouldReinitialize = false;
            
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    // Prüfe ob neue Filter hinzugefügt wurden
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1 && (
                            node.classList.contains('cloud-search-filter') ||
                            node.querySelector('.cloud-search-filter')
                        )) {
                            shouldReinitialize = true;
                        }
                    });
                }
            });
            
            if (shouldReinitialize) {
                initializeFilterToggle();
            }
        });
        
        observer.observe(targetNode, { 
            childList: true, 
            subtree: true 
        });
    }
    
    // Zusätzlicher Check alle 2 Sekunden für den Fall, dass CloudSearch sehr langsam lädt
    let checkInterval = setInterval(() => {
        const filters = document.querySelectorAll('.cloud-search-filter');
        if (filters.length > 0) {
            // Filter gefunden, prüfe ob sie korrekt initialisiert sind
            let needsInitialization = false;
            filters.forEach((filter, index) => {
                const hasExpandedClass = filter.classList.contains('expanded');
                if (index < 3 && !hasExpandedClass) {
                    needsInitialization = true;
                } else if (index >= 3 && hasExpandedClass) {
                    needsInitialization = true;
                }
            });
            
            if (needsInitialization) {
                initializeFilterToggle();
            }
            
            // Nach 10 Sekunden aufhören zu checken
            setTimeout(() => clearInterval(checkInterval), 10000);
        }
    }, 2000);
});

// Fallback-Funktion für manuelle Initialisierung
window.reinitializeFilters = function() {
    const filters = document.querySelectorAll('.cloud-search-filter');
    filters.forEach((filter, index) => {
        const content = filter.querySelector('.cloud-search-filter__content');
        if (!content) return;
        
        if (index < 3) {
            filter.classList.add('expanded');
            content.style.maxHeight = content.scrollHeight + 'px';
        } else {
            filter.classList.remove('expanded');
            content.style.maxHeight = '0';
        }
    });
};